export default __webpack_public_path__ + "static/media/jung.96d9d465.jpg";